<template>
  <div class="nu-qt-reason nu-qt-reason-new">
    <template v-if="isEditReason">
      <div class="qs-wrong-because" ref="reasonWrap">
        <div class="because-submit-wrap">
          <div class="because-content">
            <h3 v-if="oneErrVal1">
              <span class="bec-title">错因分析</span>
              <span class="bec-tip">
                标记错因，内容推送更精准，学习效果倍增</span
              >
            </h3>

            <div class="err-bec-area" v-if="oneErrVal1">
              <!--  -->
              <!-- 一级错因 -->
              <div class="err-select">
                <div class="reason-item">
                  <span class="label">一级错因</span>
                  <div class="select-btn-wrap">
                    <input
                      readonly
                      placeholder="请选择一级错因"
                      class="inner-text"
                      type="text"
                      :disabled="true"
                      v-model="oneErrVal1"
                    />
                    <i
                      :class="[
                        'arrow','down-arrow',
                      ]"
                    ></i>
                  </div>
                </div>
              </div>

              <!-- 二级错因 -->
              <div class="err-select">
                <div class="reason-item">
                  <span class="label">二级错因</span>
                  <div class="select-btn-wrap">
                    <input
                      readonly
                      placeholder="请选择二级错因"
                      :class="['inner-text', { 'is-empty': !twoErrVal }]"
                      type="text"
                      v-model="twoErrVal1"
                      :disabled="true"
                    />
                    <i
                      :class="[
                        'arrow','down-arrow',
                      ]"
                    ></i>
                  </div>
                </div>
              </div>
            </div>
            <h3>
              <span class="bec-title">AI分析错因</span>
            </h3>
            <div class="err-bec-area padding-left-12">{{error_cause_reason || '未分析出错因'}}</div>
            <h3>
              <span class="bec-title">督学师分析错因</span>
            </h3>
            <div class="err-bec-area">
              <!-- 一级错因 -->
              <div class="err-select" >
                <div class="reason-item">
                  <span class="label">一级错因</span>
                  <div class="select-btn-wrap">
                    <input
                      readonly
                      placeholder="请选择一级错因"
                      class="inner-text"
                      type="text"
                      v-model="oneErrVal"
                      :disabled="hasFeedBack || teacherInputDisable"
                      @click="showErrorList($event, 1)"
                    />
                    <i
                      :class="[
                        'arrow',
                        isShowListOne ? 'top-arrow' : 'down-arrow',
                      ]"
                    ></i>
                  </div>
                  <div
                    v-if="isShowListOne"
                    :class="['select-option-wrap', direction]"
                    v-clickoutside="handleClickOutSide"
                  >
                    <div class="scroll-wrap">
                      <ul class="select-option">
                        <li
                          v-for="(item, index) in errList"
                          :key="index"
                          :class="{
                            selected: item.selected === true,
                            hover: item.hover === true,
                          }"
                          @click="changeReasonOne(item)"
                          @mouseover="setHover(item, 1)"
                          @mouseout="setHover(item, 0)"
                        >
                          {{ item.reason }}
                        </li>
                      </ul>
                    </div>
                    <div :class="['popper-arrow', direction]"></div>
                  </div>
                </div>
              </div>

              <!-- 二级错因 -->
              <div class="err-select">
                <div class="reason-item">
                  <span class="label">二级错因</span>
                  <div class="select-btn-wrap">
                    <input
                      readonly
                      placeholder="请选择二级错因"
                      :class="['inner-text', { 'is-empty': !twoErrVal }]"
                      type="text"
                      v-model="twoErrVal"
                      :disabled="hasFeedBack || teacherInputDisable || twoReasonList.length < 1"
                      @click="showErrorList($event, 2)"
                    />
                    <i
                      :class="[
                        'arrow',
                        isShowListTwo ? 'top-arrow' : 'down-arrow',
                      ]"
                    ></i>
                  </div>
                  <div
                    v-if="isShowListTwo"
                    :class="['select-option-wrap', direction]"
                    v-clickoutside="handleClickOutSide"
                  >
                    <div class="scroll-wrap">
                      <ul class="select-option">
                        <li
                          v-for="(item, index) in twoReasonList"
                          :key="index"
                          :class="{
                            selected: item.selected === true,
                            hover: item.hover === true,
                          }"
                          @click="changeReasonTwo(item)"
                          @mouseover="setHover(item, 1)"
                          @mouseout="setHover(item, 0)"
                        >
                          {{ item.reason }}
                        </li>
                      </ul>
                    </div>
                    <div :class="['popper-arrow', direction]"></div>
                  </div>
                </div>
              </div>
            </div>
            <el-input
              v-if="oneErrVal == '这是坑题' || oneErrVal == '以上没有'"
             class="padding-left-12"
              type="textarea"
              :rows="3"
              placeholder="请填写你的分析结果"
              maxlength="500"
              :disabled="hasFeedBack"
              show-word-limit
              v-model="inputVal">
            </el-input>
            <button
              v-if="!hasFeedBack"
                :disabled="(oneErrVal != '这是坑题' && oneErrVal != '以上没有' && twoErrVal == '') || (oneErrVal == '' && twoErrVal == '')"
                :class="[
                  'err-bec-disabled-btn',
                  { 'err-bec-submit-btn': (oneErrVal == '这是坑题' || oneErrVal == '以上没有') || (oneErrVal != '' && twoErrVal != '') },
                ]"
                @click="addReason"
              >
                提交
              </button>
          </div>
          <div class="img-bg"></div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { requestHost } from '@/utils/hostsconfig'
import clickoutside from "@/utils/clickoutside";
import qs from "qs";

export default {
  name: "errorReason",
  directives: {
    clickoutside,
  },
  props: {
    isEditReason: {
      type: Boolean,
      default: false,
    },
    apiUrl: {
      type: Object,
      default: () => {
        return {};
      },
    },
    hostUrl: {
      type: String,
      default: "",
    },
    contentType: {
      type: String,
      default: "application/x-www-form-urlencoded",
    },
    params: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      editReason: true,
      errList: [],
      isShowListOne: false,
      isShowListTwo: false,
      oneErrVal: "",
      twoErrVal: "",
      oneErrValDef: "",
      twoErrValDef: "",
      oneErrVal1: "",
      twoErrVal1: "",
      inputVal: '',
      error_cause_reason:'',
      teacherInputDisable:false,
      twoReasonList: [],
      historyData: [],
      hasFeedBack:false,
      showTipOne: false,
      showTipTwo: false,
      dialogVisibleTeacher: false,
      direction: "bottom",
      language: this.$i18n.locale || 'zh',
    };
  },
  mounted() {
    // 获取错因列表
    const list = sessionStorage.getItem(`errList_${this.params.subject_id}`);
    if (list) {
      this.errList =
        JSON.parse(
          sessionStorage.getItem(`errList_${this.params.subject_id}`)
        ) || [];
      // this.getdefault();
    } else {
      this.getErrorReason({
        account_id: this.params.account_id,
        subject_id: this.params.subject_id,
      }).then((res) => {
        const reslut = res.data;
        if (reslut.code === 200) {
          this.errList = reslut.data || [];
          sessionStorage.setItem(
            `errList_${this.params.subject_id}`,
            JSON.stringify(this.errList)
          );
          // this.getdefault();
        }
      });
    }
    //ai一二级错因
    if(this.params.cause_info){
      this.oneErrVal = this.params.cause_info.error_cause_name || ''
      this.twoErrVal = this.params.cause_info.error_cause_sub_name || ''
      this.inputVal = this.params.cause_info.error_cause_reason || ''
      if(this.oneErrVal){
        this.hasFeedBack = true
      }
    }
    //ai错因分析
    if(this.params.ai_cause_info){
      this.error_cause_reason = this.params.ai_cause_info.error_cause_reason || ''
      this.oneErrVal1 = this.params.ai_cause_info.error_cause_name || ''
      this.twoErrVal1 = this.params.ai_cause_info.error_cause_sub_name || ''
    }

  },
  methods: {
    popDirection() {
      const winH =
        document.documentElement.clientHeight || document.body.clientHeight;
      const top = this.$refs.reasonWrap.getBoundingClientRect().top;
      if (winH - top < 500) {
        this.direction = "top";
      } else {
        this.direction = "bottom";
      }
    },
    showErrorList(e, num) {
      e.stopPropagation();
      if (num === 1) {
        this.isShowListOne = !this.isShowListOne;
        this.isShowListTwo = false;
      }
      if (num === 2) {
        this.isShowListTwo = !this.isShowListTwo;
        this.isShowListOne = false;
      }
      this.popDirection();
    },
    changeReasonOne(data) {
      this.errList.map((item) => {
        item.selected = false;
        if (item.errorReasonId === data.errorReasonId) {
          this.$set(item, "selected", true);
          this.twoReasonList = item.subList;
        }
      });
      if (this.twoReasonList.length === 1) {
        this.twoErrVal = this.twoReasonList[0].reason;
        this.twoErrId = this.twoReasonList[0].errorReasonId;
        this.$set(this.twoReasonList[0], "selected", true);
      } else {
        this.twoErrVal = "";
        this.twoErrId = "";
      }
      this.isShowListOne = false;
      this.oneErrVal = data.reason;
      if(this.oneErrVal != '这是坑题' && this.oneErrVal != '以上没有'){
        this.inputVal = ''
      }
    },
    changeReasonTwo(data) {
      this.twoReasonList.map((item) => {
        item.selected = false;
        if (item.errorReasonId === data.errorReasonId) {
          this.$set(item, "selected", true);
        }
      });
      this.isShowListTwo = false;
      this.twoErrVal = data.reason;
    },
    // 获取默认值
    async getdefault() {
      // 获取错因默认值
      const {
        app_id,
        account_id,
        user_id,
        detail_id,
        subject_id,
        feedback_sence,
        teacher_id,
      } = this.params;
      const res = await this.getQuestionFeedbackDetail({
        app_id: app_id,
        account_id: account_id,
        user_id: user_id,
        detail_id: detail_id,
        subject_id: subject_id,
        feedback_sence: feedback_sence,
        teacher_id: teacher_id,
      });

      if (res && res.data.code === 200) {
        const reslut = res.data;
        let defaultVal = {};
        if (!reslut.data.length || !reslut.data[0].feedContent) return;
        this.historyData = reslut.data || [];
        defaultVal = this.errList.find((item) => {
          return (
            reslut.data[0].feedContent.errorReasonId === item.errorReasonId
          );
        });
        if (defaultVal && defaultVal.reason) {
          defaultVal.subList &&
            defaultVal.subList.length &&
            defaultVal.subList.forEach((element) => {
              if (
                element.errorReasonId ===
                reslut.data[0].feedContent.subList.errorReasonId
              ) {
                this.twoErrVal = element.reason || "";
                this.twoErrId = element.errorReasonId || "";
              }
            });
          this.twoReasonList = defaultVal.subList;
          this.oneErrVal = defaultVal.reason || "";
          this.oneErrId = defaultVal.errorReasonId || "";
          this.oneErrValDef = this.oneErrVal;
          this.twoErrValDef = this.twoErrVal || "暂无";
          this.editReason = false;
        }
      }
    },
    // 获取错因默认值api
    getQuestionFeedbackDetail: function (data) {
      const params =
        this.contentType === "application/x-www-form-urlencoded"
          ? qs.stringify(data)
          : JSON.stringify(data);
      if (sessionStorage.getItem("yx_token")) {
        return this.$http.post(requestHost + this.apiUrl.errDefaultVal, params, {
          headers: {
            "yx-token": sessionStorage.getItem("yx_token"),
          },
        });
      } else {
        return this.$http.post(requestHost + this.apiUrl.errDefaultVal, params);
      }
    },
    // 获取错因列表api
    getErrorReason: function (data) {
      // console.log('错因列表参数???', data)
      const params =
        this.contentType === "application/x-www-form-urlencoded"
          ? qs.stringify(data)
          : JSON.stringify(data);
      if (sessionStorage.getItem("yx_token")) {
        return this.$http.post(requestHost + '/question/getAiReasonList', params, {
          headers: {
            "yx-token": sessionStorage.getItem("yx_token"),
          },
        });
      } else {
        return this.$http.post(requestHost + '/question/getAiReasonList', params);
      }
    },
    // 添加错因api
    feedback: function (data) {
      const params =
        this.contentType === "application/x-www-form-urlencoded"
          ? qs.stringify(data)
          : JSON.stringify(data);
      if (sessionStorage.getItem("yx_token")) {
        return this.$http.post(requestHost + '/question/setTeacherErrorCause', params, {
          headers: {
            "yx-token": sessionStorage.getItem("yx_token"),
          },
        });
      } else {
        return this.$http.post(requestHost + '/question/setTeacherErrorCause', params);
      }
    },
    // 添加错因
    async addReason() {
      // if (!this.oneErrVal || !this.twoErrVal) {
      //   return;
      // }
      let feedContent = {
        errorReasonId: "",
        subList: { errorReasonId: "" },
        inputVal:this.inputVal,
      };
        const content = this.errList.filter((item) => {
          return item.reason === this.oneErrVal;
        });
        feedContent.errorReasonId = content[0].errorReasonId;
        feedContent.reason = content[0].reason;
        content[0].subList &&
          content[0].subList.forEach((item) => {
            if (item.reason === this.twoErrVal) {
              feedContent.subList = {
                errorReasonId: item.errorReasonId,
                reason:item.reason
              };
            }
          });
      
      const res = await this.feedback({
        // feed_content: JSON.stringify(feedContent),
        error_cause_code:feedContent.errorReasonId,
        error_cause_name:feedContent.reason,
        error_cause_sub_code:feedContent.subList.errorReasonId || '',
        error_cause_sub_name: feedContent.subList.reason || '',
        error_cause_reason:this.inputVal,
        ...this.params,
      });
      const reslut = res.data;
      if (res && reslut.code !== 200) {
        this.$toast({
          message: reslut.message || reslut.msg,
          duration: 1000,
        });
        // this.oneErrVal = this.oneErrValDef;
        // this.twoErrVal = this.twoErrValDef;
        // this.editReason = false;
        return;
      }

      if (res && reslut.code === 200) {
        this.$toast({
          message: "已收到你的反馈，非常感谢~",
          duration: 1000,
        });
        // this.oneErrValDef = this.oneErrVal;
        // this.twoErrValDef = this.twoErrVal;
        // this.editReason = false;
        this.hasFeedBack = true
      }
    },
    setHover(data, mk) {
      this.errList.map((item) => {
        this.$set(item, "hover", false);
        if (item.errorReasonId === data.errorReasonId && mk === 1) {
          this.$set(item, "hover", true);
        }
        if (item.errorReasonId === data.errorReasonId && mk === 0) {
          this.$set(item, "hover", false);
        }
      });
    },
    hiddenSelection() {
      this.hasClass = "0";
      this.isShowList = false;
    },
    handleClickOutSide(e) {
      // 当外部被点击时调用
      this.isShowListOne = false;
      this.isShowListTwo = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.nu-qt-reason-new{
  width: 100%;
  .qs-wrong-because{
    .because-submit-wrap {
      align-items: flex-end;
      .img-bg{
        margin-bottom: 28px;
      }
      .because-content{
        .err-bec-disabled-btn{
          width: 120px;
          height: 32px;
          margin-top: 8px;
          padding: 0;
          line-height: 32px;
          border-radius: 16px;
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #ffffff;
          border: none;
          background-image: linear-gradient(45deg, #ddecf7 0%, #dbe3ef 100%);
          outline: 0;
          cursor: default;
          float: right;
        }
        .err-bec-submit-btn{
          cursor: pointer;
          background-image: linear-gradient(38deg, #66bcf5 28%, #8eabfa 100%);
        }
        h3{
          margin-top: 8px;
        }
        .err-bec-area{
          margin-top: 8px;
          margin-bottom: 16px;
          display: flex;
        }
        .padding-left-12{
          position: relative;
          padding-left: 12px;
          box-sizing: border-box;
          ::v-deep textarea{
            padding-bottom: 20px;
          }
          ::v-deep .el-input__count{
            position: absolute;
            bottom: 4px !important;
            right: 24px;
            // color: #444B65;
          }
        }
      }
    }
  }
}
.qs-wrong-because {
  margin-top: 32px;
  padding-bottom: 20px;
  background-image: linear-gradient(-180deg, #ffffff 0%, #f1f9ff 100%);
  border: 1px solid #dee5f0;
  border-radius: 8px;
  color: #606b7d;
  p {
    margin: 0;
    padding: 0;
  }
  .because-submit-wrap {
    display: flex;
    .because-content {
      width: calc(100% - 218px);
      margin: 20px 0 0 16px;
      font-size: 14px;
      h3 {
        margin: 0;
        padding: 0;
        font-weight: normal;
        .bec-title {
          margin-right: 4px;
          font-family: PingFangSC-Semibold;
          font-size: 16px;
          color: #3d474f;
        }
        .bec-tip {
          font-family: PingFangSC-Regular;
          font-size: 12px;
          color: #8994a4;
        }
      }
      .err-bec-area {
        margin-top: 30px;
        .err-select {
          position: relative;
          float: left;
          box-sizing: border-box;
          width: 38%;
          padding: 0 12px;
          .reason-item {
            position: relative;
          }
        }
        .err-bec-disabled-btn {
          width: 120px;
          height: 32px;
          margin-top: 28px;
          padding: 0;
          line-height: 32px;
          border-radius: 16px;
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #ffffff;
          border: none;
          background-image: linear-gradient(45deg, #ddecf7 0%, #dbe3ef 100%);
          outline: 0;
          cursor: default;
        }
        .err-bec-submit-btn {
          cursor: pointer;
          background-image: linear-gradient(38deg, #66bcf5 28%, #8eabfa 100%);
        }
        .err-bec-submit-btn:hover {
          background-image: linear-gradient(45deg, #5ba8dc 0%, #70a0de 100%);
        }
      }
      .submit-bec-wrap {
        .err-bec-disabled-btn {
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #ffffff;
          border: none;
          background-image: linear-gradient(45deg, #ddecf7 0%, #dbe3ef 100%);
        }
        .err-bec-submit-btn {
          background-image: linear-gradient(38deg, #66bcf5 28%, #8eabfa 100%);
        }
        .err-bec-submit-btn:hover {
          background-image: linear-gradient(45deg, #5ba8dc 0%, #70a0de 100%);
        }
      }
    }
    .img-bg {
      flex: 0 0 161px;
      width: 161px;
      height: 175px;
      margin-top: 12px;
      margin-right: 27px;
      margin-left: 40px;
      background: url('~@/assets/images/error_bg.png') no-repeat;
      // background: url("data:image/png;base64,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")
      //   no-repeat;
      background-size: 100% 100%;
    }
  }
  .err-bec-default {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin: 16px 24px 0 24px;
    line-height: 40px;
    span {
      padding-left: 56px;
      background: url("data:image/png;base64,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")
        no-repeat;
      background-size: 41px 40px;
      font-family: SourceHanSansCN-Medium;
      font-size: 16px;
      color: #4b4f54;
    }
    .show-eason {
      display: flex;
      margin-left: 32px;
      color: #606b7d;
      font-size: 14px;
      .text {
        position: relative;
        .content {
          width: 10rem;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          text-align: left;
          cursor: pointer;
        }
        .tip-wrap {
          position: absolute;
          padding: 0 12px;
          transform-origin: center top;
          z-index: 2031;
          border: 1px solid #e4e7ed;
          border-radius: 4px;
          background-color: #fff;
          box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.1);
          box-sizing: border-box;
          white-space: nowrap;
          &.top {
            left: 0;
            bottom: 40px;
            .popper-arrow {
              top: 40px;
              bottom: -12px;
              border-bottom-width: 0;
              border-top-color: #fff;
              &::after {
                display: none;
              }
            }
          }
        }
      }
    }
  }
  .edit-btn {
    width: 72px;
    height: 28px;
    margin-left: auto;
    line-height: 28px;
    padding: 0;
    border: 1px solid #6fbff7;
    border-radius: 14px;
    color: #6fbff7;
    background: #fff;
    cursor: pointer;
    outline: 0;
    i {
      font-size: 14px;
    }
    &:hover {
      background: #dfecf5;
    }
  }
  .select-btn-wrap {
    position: relative;
    margin-top: 8px;
    font-size: 14px;
    .inner-text {
      box-sizing: border-box;
      width: 100%;
      height: 32px;
      line-height: 32px;
      padding-left: 15px;
      padding-right: 30px;
      border-radius: 16px;
      border: 2px solid #d8dee8;
      outline: 0;
      color: #606266;
      cursor: pointer;
      &::-webkit-input-placeholder {
        /* 使用webkit内核的浏览器 */
        font-weight: 400;
        padding-left: 5px;
        color: rgba(181, 197, 213, 1);
        line-height: 22px;
      }
      &:-moz-placeholder {
        /* Firefox版本4-18 */
        font-weight: 400;
        color: rgba(181, 197, 213, 1);
        padding-left: 5px;
        line-height: 22px;
      }
      &::-moz-placeholder {
        /* Firefox版本19+ */
        font-weight: 400;
        color: rgba(181, 197, 213, 1);
        padding-left: 5px;
        line-height: 22px;
      }
      &:-ms-input-placeholder {
        /* IE浏览器 */
        font-weight: 400;
        padding-left: 8px;
        color: rgba(181, 197, 213, 1);
        line-height: 22px;
      }
    }
    .arrow {
      position: absolute;
      right: 12px;
    }
  }
  .select-option-wrap {
    min-width: 210px;
    position: absolute;
    top: 60px;
    left: 0;
    max-height: 270px;
    transform-origin: center top;
    z-index: 2031;
    border: 1px solid #e4e7ed;
    border-radius: 4px;
    background-color: #fff;
    box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.1);
    box-sizing: border-box;
    margin: 5px 0;
    &.top {
      bottom: 40px;
      top: inherit;
    }
    &.bottom {
      top: 60px;
      bottom: inherit;
    }
    .scroll-wrap {
      max-height: 250px;
      overflow-y: auto;
    }
    .select-option {
      list-style: none;
      margin: 0;
      padding: 6px 0;
      box-sizing: border-box;
      > li {
        font-size: 14px;
        padding: 0 20px;
        position: relative;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        color: #606266;
        height: 34px;
        line-height: 34px;
        box-sizing: border-box;
        cursor: pointer;
        &.hover,
        &:hover {
          background-color: #f5f7fa;
        }
        &.selected {
          color: #6fbff7;
        }
      }
    }
  }
  .popper-arrow {
    position: absolute;
    top: -12px;
    left: 35px;
    margin-right: 3px;
    display: block;
    width: 0;
    height: 0;
    border-color: transparent;
    border-style: solid;
    border-top-width: 0;
    border-bottom-color: #ebeef5;
    border-width: 6px;
    -webkit-filter: drop-shadow(0 2px 12px rgba(0, 0, 0, 0.03));
    filter: drop-shadow(0 2px 12px rgba(0, 0, 0, 0.03));
    &.top {
      bottom: -8px;
      top: inherit;
      border-bottom-width: 0;
      border-top-color: #ebeef5;
      &::after {
        width: 0;
        height: 0;
        bottom: 2px;
        top: inherit;
        border-bottom-width: 0;
        border-top-color: #fff;
        border-width: 6px;
        border-width: 6px;
        border-bottom-width: 0;
      }
    }
    &::after {
      position: absolute;
      display: block;
      width: 0;
      height: 0;
      border-color: transparent;
      border-style: solid;
      content: "";
      top: 1px;
      margin-left: -6px;
      border-width: 6px;
      border-top-width: 0;
      border-bottom-color: #fff;
    }
  }
  // 向上箭头
  .top-arrow {
    width: 8px;
    height: 8px;
    top: 12px;
    border-top: 1px solid rgba(195, 199, 208, 1);
    border-left: 1px solid rgba(195, 199, 208, 1);
    transform: rotate(45deg);
    display: inline-block;
    transition: all 0.3s;
  }
  // 向下箭头
  .down-arrow {
    width: 8px;
    height: 8px;
    top: 8px;
    border-top: 1px solid rgba(195, 199, 208, 1);
    border-left: 1px solid rgba(195, 199, 208, 1);
    transform: rotate(225deg);
    display: inline-block;
    transition: all 0.3s;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/errorReasonNew.vue